/**
 * Date-extensions locale Swahili [sw]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sw', {
    monthNames: ['Januari','Februari','Machi','Aprili','Mei','Juni','Julai','Agosti','Septemba','Oktoba','Novemba','Desemba'],
    monthShortNames: ['Jan','Feb','Mac','Apr','Mei','Jun','Jul','Ago','Sep','Okt','Nov','Des'],
    dayNames: ['Jumapili','Jumatatu','Jumanne','Jumatano','Alhamisi','Ijumaa','Jumamosi'],
    dayShortNames: ['Jpl','Jtat','Jnne','Jtan','Alh','Ijm','Jmos']
});
